<h2 mat-dialog-title>Reason for decline</h2>
<mat-dialog-content #dialogBody class="dialog-content">
  <p class="dialog-intro">
    Feedback for <strong>{{ recordingName }}</strong> at {{ stationLabel }}. The station's reason is first, then any replies.
  </p>
  @if (carriedFromId) {
    <p class="hint">
      This thread was carried over from recording #{{ carriedFromId }}, including the original decline reason and replies.
    </p>
  }

  @if (loading) {
    <div class="thread-loading" role="status">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading feedback…</span>
    </div>
  } @else if (messages.length === 0 && !error) {
    <p class="muted">No feedback has been recorded for this station yet.</p>
  } @else {
    <div class="qa-history">
      @for (msg of messages; track msg.id; let i = $index) {
        <div class="qa-item" [class.from-station]="!isFromUploader(msg)" [class.from-user]="isFromUploader(msg)">
          <span class="qa-label">{{ messageLabel(msg, i) }}</span>
          <p class="qa-text">{{ msg.message_text }}</p>
          @if (msg.created_at) {
            <span class="qa-meta">{{ msg.created_at | date:'short' }}</span>
          }
        </div>
      }
    </div>
  }

  <div class="reply-form">
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>{{ isUploader ? 'Your reply' : 'Reply to uploader' }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="replyText"
        name="reply"
        rows="3"
        [maxlength]="maxChars"
        [disabled]="sending || loading || submitting"></textarea>
    </mat-form-field>
    <div class="reply-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="sendReply()"
        [disabled]="!canReply">
        @if (sending) { Sending... } @else { Send reply }
      </button>
    </div>
  </div>

  @if (canOfferCorrected) {
    <section class="corrected-section" aria-label="Submit corrected recording">
      <h3>Submit a corrected recording</h3>
      <p class="hint">Choose a new MP3. This station gets a new recording; the declined one is marked superseded.</p>

      <div class="uploader" [class.uploader--has-file]="!!selectedFileName">
        <mat-icon aria-hidden="true">cloud_upload</mat-icon>
        <p>Choose an MP3 file</p>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="correctedFileInput.click()"
          [disabled]="submitting || uploading">
          <mat-icon aria-hidden="true">folder_open</mat-icon>
          Choose File
        </button>
        <input
          #correctedFileInput
          type="file"
          [accept]="audioAccept"
          (change)="onAudioSelected($event)"
          hidden />
        @if (selectedFileName) {
          <p class="uploader-file-name">{{ selectedFileName }}</p>
        }
        @if (uploading) {
          <span class="upload-status">
            <mat-spinner diameter="16"></mat-spinner>
            Uploading…
          </span>
        }
      </div>

      <div class="reply-actions">
        <button
          type="button"
          class="btn-primary"
          (click)="submitCorrected()"
          [disabled]="!canSubmitCorrected">
          @if (submitting) {
            <mat-spinner diameter="18"></mat-spinner>
            Submitting…
          } @else {
            Submit Corrected Recording
          }
        </button>
      </div>
    </section>
  }

  @if (error) {
    <p class="submit-error" role="alert">{{ error }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button type="button" (click)="close()" [disabled]="sending || submitting">Close</button>
</mat-dialog-actions>
